import { useCallback, useState } from 'react';
import { useSelectionMode } from '@/contexts/SelectionModeContext';

export interface UseCanvasHandlersDeps {
  setSelectedBlockId: (id: string | null) => void;
  setSelectedGroupId: (id: string | null) => void;
}

export function useCanvasHandlers(deps: UseCanvasHandlersDeps) {
  const { setSelectedBlockId, setSelectedGroupId } = deps;
  const { setSelectedConnectorId } = useSelectionMode();
  const [announcement, setAnnouncement] = useState('');

  const announce = useCallback((msg: string) => {
    setAnnouncement('');
    requestAnimationFrame(() => setAnnouncement(msg));
  }, []);

  const handleCanvasClick = useCallback(() => {
    setSelectedBlockId(null);
    setSelectedGroupId(null);
    setSelectedConnectorId(null);
  }, [setSelectedBlockId, setSelectedGroupId, setSelectedConnectorId]);

  return { announcement, announce, handleCanvasClick };
}
